<template>
  <div>
    <el-row type="flex" :gutter="20">
      <el-col :span="12" class="margin-top-20">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <!-- <i class="el-icon-s-data"></i> -->
            <b class="font-size-18">近30天接口请求趋势 <small> (点击切换其他日期)</small></b>
          </div>
          <div id="barChart" class="chart-box user-chart-box"
          v-loading="recentTdendencyLoading"></div>
        </el-card>
      </el-col>
      <el-col :span="12" class="margin-top-20">
        <el-card shadow="never">
          <div slot="header" class="clearfix">
            <!-- <i class="el-icon-s-data"></i> -->
            <b class="font-size-18">接口请求趋势</b>
          </div>
          <div id="lineChart" class="chart-box user-chart-box" v-loading="tendencyLoading"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { queryApiTendency } from '@/api/tracking';
// import { parseTime } from '@/utils';
import Moment from 'moment';
import { getMiddleData } from '@/utils/index';

export default {
  props: {
    recentTdendencyLoading: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: '',
    },
    analyzeTime: {
      type: String,
      default: '',
    },
    xBarArray: {
      type: Array,
      default: null,
    },
    yBarArray: {
      type: Array,
      default: null,
    },
    isMountedRender: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tendencyLoading: false,
      xLineArray: [],
      yLineArray: [],
      yLineErrorArray: [],
      barChart: null,
      lineChart: null,
    };
  },
  computed: {
    ...mapGetters('app', ['source', 'env', 'serverName', 'bizChannel']),
  },
  watch: {
    recentTdendencyLoading: {
      handler() {
        this.renderBarChart();
      },
    },
    analyzeTime: {
      handler() {
        this.search();
      },
    },
    env: {
      handler() {
        this.search();
      },
    },
    serverName: {
      handler() {
        this.search();
      },
    },
    bizChannel: {
      handler() {
        this.search();
      },
    },
    url: {
      handler() {
        this.search();
      },
    },
    xBarArray: {
      handler() {
        this.renderBarChart();
      },
      deep: true,
    },
    yBarArray: {
      handler() {
        this.renderBarChart();
      },
      deep: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.barChart = this.$echarts.init(document.getElementById('barChart'));
    this.lineChart = this.$echarts.init(document.getElementById('lineChart'));

    this.handleBarClick();
    if (this.isMountedRender) {
      this.renderBarChart();
      this.recentLoading = false;
      this.search();
    } else {
      const option = this.renderLineChart(
        new Array(24).fill(0).map((_item, index) => `${index < 10 ? `0${index}` : `${index}`}:00`),
        [0],
        [0],
      );
      this.lineChart.setOption(option);
    }

    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    // 点击柱状图切换日期
    handleBarClick() {
      // echart全图移入鼠标事件
      this.barChart.getZr().on('mousemove', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (this.barChart.containPixel('grid', pointInPixel)) {
          // 将此区域的 鼠标样式变为 小手
          this.barChart.getZr().setCursorStyle('pointer');
        }
      });
      // echart全图点击事件
      this.barChart.getZr().on('click', (param) => {
        // 获取 点击的 触发点像素坐标
        const pointInPixel = [param.offsetX, param.offsetY];
        // 判断给定的点是否在指定的坐标系或者系列上
        if (this.barChart.containPixel('grid', pointInPixel)) {
          // 获取到点击的 x轴 下标  转换为逻辑坐标
          const xIndex = this.barChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
          const [month, date] = this.xBarArray[xIndex].split('-');
          // 日期拼接年份
          const newDate = new Date();
          let curYear = newDate.getFullYear();
          const curMonth = newDate.getMonth() + 1;
          if (month > curMonth) {
            // 点击的月份，大于当前月份，就是去年的了
            curYear -= 1;
          }
          const clickDate = `${curYear}-${month}-${date}`;

          const params = {
            analyzeTimeFrom: `${clickDate} 00:00:00`,
            analyzeTimeTo: `${clickDate} 23:59:59`,
          };
          this.$emit('handleSwitch', clickDate);
          // 趋势图
          this.renderLineData(params);

          this.renderBarChart();
        }
      });
      // this.barChart.on('click', (item) => {
      //   const {
      //     name,
      //   } = item;
      //   const [month, date] = name.split('-');
      //   // 日期拼接年份
      //   const newDate = new Date();
      //   let curYear = newDate.getFullYear();
      //   const curMonth = newDate.getMonth() + 1;
      //   if (month > curMonth) {
      //     // 点击的月份，大于当前月份，就是去年的了
      //     curYear -= 1;
      //   }
      //   const clickDate = `${curYear}-${month}-${date}`;

      //   const params = {
      //     analyzeTimeFrom: `${clickDate} 00:00:00`,
      //     analyzeTimeTo: `${clickDate} 23:59:59`,
      //   };
      //   this.$emit('handleSwitch', clickDate);
      //   // 趋势图
      //   this.renderLineData(params);

      //   this.renderBarChart();
      // });
    },
    // 柱状图渲染
    renderBarChart() {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          height: '160',
          left: '2%',
          right: '2%',
          bottom: '0%',
          containLabel: true,
        },
        color: ['#5d5cb6'],
        xAxis: [
          {
            type: 'category',
            data: this.xBarArray,
            // 设置轴线的属性
            axisLine: {
              lineStyle: {
                type: 'dashed',
                color: '#838383', // width: 8
              },
            },
            axisLabel: {
              interval: 0,
              rotate: 30,
              // textStyle: {
              color: '#838383', // 坐标值得具体的颜色
              // },
            },
          },
        ],
        yAxis: [
          {
            name: '次数',
            type: 'value', // 网格
            splitLine: { show: false }, // 设置轴线的属性
            axisLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#838383',
                // width: 8
              },
            },
            // 数值
            axisLabel: {
              // textStyle: {
              color: '#838383', // 坐标值得具体的颜色
              // },
            },
          },
        ],
        series: [
          {
            name: '发生次数',
            barWidth: 15, // 柱图宽度
            type: 'bar',
            emphasis: {
              focus: 'series',
            },
            data: this.yBarArray,
          },
        ],
      };
      this.barChart.setOption(option);
    },
    async search() {
      const {
        analyzeTime,
      } = this;
      if (!analyzeTime) {
        // 趋势堆叠图数据初始化
        const today = new Moment().format('YYYY-MM-DD');
        const startTime = `${today} 00:00:00`;
        const endTime = `${today} 23:59:59`;
        this.xLineArray = getMiddleData('hour', startTime, endTime, 'HH:mm');
        this.yLineArray = [0];
        this.yLineErrorArray = [0];
        this.lineChart.clear(); // 消除当前实例
        const option = this.renderLineChart(this.xLineArray, this.yLineArray, this.yLineErrorArray);
        this.lineChart.setOption(option);
        return;
      }
      // const referAnalyzeTime = parseTime(
      //   new Date(new Date(analyzeTime).getTime() - 604800000),
      //   'yyyy-MM-dd',
      // );
      const params = {
        uri: this.url,
        analyzeTimeFrom: `${analyzeTime} 00:00:00`,
        analyzeTimeTo: `${analyzeTime} 23:59:59`,
        // referAnalyzeTime,
      };
      this.renderLineData(params);
    },
    // 折线图数据
    async renderLineData(params) {
      this.tendencyLoading = true;

      let xArray = [];
      const yArray = [];
      const yErrorArray = [];
      const startTime = `${this.analyzeTime} 00:00:00`;
      const endTime = `${this.analyzeTime} 23:59:59`;
      const middle = getMiddleData('hour', startTime, endTime, 'HH:mm');
      // const curHours = `${new Date().getHours()}:00`;
      const curHours = new Date().getHours() < 10 ? `0${new Date().getHours()}:00` : `${new Date().getHours()}:00`;
      console.log('curHours', curHours);
      const today = new Moment().format('YYYY-MM-DD');
      xArray = middle;
      this.xLineArray = xArray;

      const {
        data: { apiTendencies },
      } = await queryApiTendency(params);
      const array = apiTendencies;

      this.tendencyLoading = false;
      middle.forEach((task) => {
        // eslint-disable-next-line no-return-assign, no-param-reassign
        const arr = array.find(
          // eslint-disable-next-line comma-dangle
          (item) => item.currentAnalyzeTime.slice(11, 16) === task
        );
        if (arr) {
          yArray.push(arr.currentApiRequest);
          yErrorArray.push(arr.currentApiError);
        } else {
          yArray.push(0);
          yErrorArray.push(0);
          if (this.analyzeTime === today) {
            // 当天截断当前时间之后的0
            const index = xArray.indexOf(curHours);
            yArray.splice(index + 1);
            yErrorArray.splice(index + 1);
          }
        }
      });

      if (yArray.length > 0) {
        this.yLineArray = yArray;
        this.yLineErrorArray = yErrorArray;
      }
      // array.forEach(({ currentApiError, currentApiRequest }) => {
      //   // xArray.push(currentAnalyzeTime.slice(11, 16));
      //   yArray.push(currentApiRequest);
      //   yErrorArray.push(currentApiError);
      // });
      this.lineChart.clear(); // 消除当前实例
      const option = this.renderLineChart(this.xLineArray, this.yLineArray, this.yLineErrorArray);
      this.lineChart.setOption(option);
    },
    // 线堆叠
    renderLineChart(xLineArray, yLineArray, yLineErrorArray) {
      return {
        // 平滑
        smooth: true,
        legend: { right: 'auto' },
        tooltip: {
          trigger: 'axis',
          backgroundColor: null,
          borderWidth: 0,
          borderRadius: 0,
          axisPointer: {
            type: 'line',
            axis: 'x',
            label: {
              show: true,
              color: 'rgb(255, 151, 36)',
              backgroundColor: 'rgba(255, 255, 255, .8)',
              shadowBlur: 0,
              margin: 0,
            },
            lineStyle: {
              type: 'dashed',
              color: '#b6b5b7',
            },
          },
          textStyle: {
            color: '#333',
            align: 'left',
            fontSize: 14,
          },
          formatter(params) {
            const res = `
              <div style="
                padding: 10px;
                box-shadow: 0 0 3px 3px rgba(0,0,0, .09);
                background: #fff;
                border-radius: 5px;"
              >
                <div>${params[0].axisValueLabel}</div>
                <div style="display: flex;min-width: 120px;justify-content: space-between">
                  <div>
                    <p
                      style="
                      display: inline-block;
                      border-radius: 10px;
                      height: 10px;
                      width: 10px;
                      background-color: ${params[0].color};"
                    ></p>
                    ${params[0].seriesName}
                  </div>
                  <p><strong>${params[0].value}</strong></p>
                </div>
                <div style="display: flex;min-width: 120px;justify-content: space-between">
                  <div>
                    <p
                      style="
                      display: inline-block;
                      border-radius: 10px;
                      height: 10px;
                      width: 10px;
                      background-color: ${params[1].color};"
                    ></p>
                    ${params[1].seriesName}
                  </div>
                  <p><strong>${params[1].value}</strong></p>
                </div>
              </div>`;
            return res;
          },
          position(point, params, dom, rect, size) {
            // 其中point为当前鼠标的位置，size中有两个属性：viewSize和contentSize，分别为外层div和tooltip提示框的大小
            const x = point[0]; //
            const y = point[1];
            const boxWidth = size.contentSize[0];
            const boxHeight = size.contentSize[1];
            let posX = 0; // x坐标位置
            let posY = 0; // y坐标位置

            if (x < boxWidth) {
              // 左边放不开
              posX = 5;
            } else {
              // 左边放的下
              posX = x - boxWidth;
            }

            if (y < boxHeight) {
              // 上边放不开
              posY = 5;
            } else {
              // 上边放得下
              posY = y - boxHeight;
            }

            return [posX, posY];
          },
        },
        // toolbox: {
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none',
        //     },
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        grid: {
          height: '200',
          left: '0%',
          right: '2%',
          bottom: '4%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xLineArray,
          // 设置轴线的属性
          axisLine: {
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            // textStyle: {
            color: '#b6b5b7', // 坐标值得具体的颜色
            // },
          },
        },
        yAxis: {
          type: 'value',
          boundaryGap: false,
          // 设置轴线的属性
          axisLine: {
            show: true,
            lineStyle: {
              color: '#f2f2f2',
              // width: 8
            },
          },
          // 网格
          splitLine: {
            show: false,
          },
          axisLabel: {
            // textStyle: {
            color: '#b6b5b7', // 坐标值得具体的颜色
            // },
          },
        },
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     start: 0,
        //     end: 10,
        //   },
        //   {
        //     start: 0,
        //     end: 10,
        //   },
        // ],
        series: [
          {
            name: '请求量',
            type: 'line',
            smooth: true, // 设置折线图平滑
            lineStyle: {
              width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: 'rgb(64,158,255)',
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(64,158,255)',
                },
                {
                  offset: 1,
                  color: 'rgb(251, 252, 255)',
                },
              ]),
            },
            data: yLineArray,
          },
          {
            name: '错误量',
            type: 'line',
            smooth: true, // 设置折线图平滑
            lineStyle: {
              width: 4,
              type: 'solid', // 'dotted'虚线 'solid'实线
            },
            itemStyle: {
              color: 'rgb(245,108,108)',
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(245,108,108)',
                },
                {
                  offset: 1,
                  color: 'rgb(253,226,226)',
                },
              ]),
            },
            data: yLineErrorArray,
          },
        ],
      };
    },
    handleResize() {
      this.barChart.resize();
      this.lineChart.resize();
    },
  },
};
</script>
<style lang="scss" scoped>
.user-chart-box {
  height: 220px;
}
</style>
